import AddressSearchField from './AddressSearchField.component';

export default AddressSearchField;